var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiamBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 69,
    viewBox: "0 0 300 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4351 30.3934C76.7074 26.459 78.7286 21.9344 78.7286 17.5082C78.7286 7.08197 74.0125 0 58.7096 0H0V68.8525H61.5969C76.8999 68.8525 83.5408 59.8033 83.5408 48.4918C83.5408 41.0164 79.306 34.7213 73.4351 30.3934ZM25.0237 16.7213H48.1226C50.625 16.7213 53.7048 16.7213 53.7048 20.459C53.7048 24.1967 50.625 24.1967 48.1226 24.1967H25.0237V16.7213ZM52.9349 50.1639H25.0237V42.8852H52.9349C55.4372 42.8852 58.5171 42.8852 58.5171 46.5246C58.5171 50.1639 55.4372 50.1639 52.9349 50.1639Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.644 0H82.6205V68.8525H107.644V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.17 68.8525H198.696L170.785 0H133.634L105.723 68.8525H133.249L137.869 56.459H166.55L171.17 68.8525ZM144.414 38.7541L152.209 17.7049L160.005 38.7541H144.414Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0H269.202L248.413 39.3443L227.624 0H196.825V68.8525H221.849V36.0984L240.232 68.8525H256.593L274.976 36.0984V68.8525H300V0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiamBlack);
export default __webpack_public_path__ + "static/media/biam_black.d0016f4f9a7be6d96b7e3e0159787882.svg";
export { ForwardRef as ReactComponent };